export const Text = {
  variants: {
    lead: {
      fontSize: "xl",
    },
    "body-large": {
      fontSize: "lg",
      lineHeight: "short",
    },
    body: {
      fontSize: "md",
    },

    "body-bold": {
      fontSize: "md",
      fontWeight: "bold",
    },
    button: {
      fontSize: "md",
      fontWeight: "bold",
    },
    "subtitle-bold": {
      fontSize: "sm",
      lineHeight: "normal",
      fontWeight: "bold",
    },
    subtitle: {
      fontSize: "sm",
      lineHeight: "normal",
    },

    "body-short": {
      fontSize: "md",
      lineHeight: "short",
    },
    "label-bold": {
      fontSize: "sm",
      fontWeight: "bold",
      lineHeight: "tiny",
      letterSpacing: "wide",
      textTransform: "uppercase",
      color: "whiteAlpha.500",
    },
    label: {
      fontSize: "sm",
      lineHeight: "tiny",
      letterSpacing: "wide",
      textTransform: "uppercase",
      color: "whiteAlpha.500",
    },
    small: {
      fontSize: "xs",
      fontWeight: "normal",
      lineHeight: "tiny",
      letterSpacing: "wide",
      textTransform: "uppercase",
      color: "whiteAlpha.500",
    },
    "small-bold": {
      fontSize: "xs",
      fontWeight: "bold",
      lineHeight: "tiny",
      letterSpacing: "wide",
      color: "whiteAlpha.500",
    },
  },
};
